<template>

    <h1 v-if="!darkMode" class="h1Text">Savoirs-être</h1>

    <section v-if="!darkMode">
    
    <div class="container">

        <div class="mesLogos">
        <router-link to="/">
          <img src="@/assets/home_blue.png" alt="logo Accueil" class="logo" />
        </router-link>
        <router-link to="/mescompetences">
          <img src="@/assets/arrow_back_blue.png" alt="Arrow back" class="logo" />
        </router-link>
        </div>

        <div class="card">
            
            <div class="box">
                <div>
                    <div class="percent">
                        <svg>
                            <circle cx="70" cy="70" r="70"></circle>
                            <circle class="cercle2" cx="70" cy="70" r="70"></circle>
                        </svg>
                        <div class="number">
                            <h2>70<span>%</span></h2>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text text1">SCRUM</div>

        </div>

        <div class="card">

            <div class="box">
                <div>
                    <div class="percent">
                        <svg>
                            <circle cx="70" cy="70" r="70"></circle>
                            <circle class="cercle2" cx="70" cy="70" r="70"></circle>
                        </svg>
                        <div class="number">
                            <h2>80<span>%</span></h2>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text text2">Coopération</div>

        </div>

        <div class="card">

            <div class="box">
                <div>
                    <div class="percent">
                        <svg>
                            <circle cx="70" cy="70" r="70"></circle>
                            <circle class="cercle2" cx="70" cy="70" r="70"></circle>
                        </svg>
                        <div class="number">
                            <h2>80<span>%</span></h2>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text text3">Travail d'équipe</div>

        </div>

        <div class="card">

            <div class="box">
                <div>
                    <div class="percent">
                        <svg>
                            <circle cx="70" cy="70" r="70"></circle>
                            <circle class="cercle2" cx="70" cy="70" r="70"></circle>
                        </svg>
                        <div class="number">
                            <h2>80<span>%</span></h2>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text text3">Créativité</div>

        </div>

        <div class="card">

            <div class="box">
                <div>
                    <div class="percent">
                        <svg>
                            <circle cx="70" cy="70" r="70"></circle>
                            <circle class="cercle2" cx="70" cy="70" r="70"></circle>
                        </svg>
                        <div class="number">
                            <h2>80<span>%</span></h2>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text text4">Autonomie</div>

        </div>

  
    </div>

</section>

<h1 v-if="darkMode" class="h1TextDark">Savoirs-être</h1>

    <section v-if="darkMode">
    
    <div class="container">

        <div class="mesLogos">
        <router-link to="/">
          <img src="@/assets/home_white.png" alt="logo Accueil" class="logo" />
        </router-link>
        <router-link to="/mescompetences">
          <img src="@/assets/arrow_back_white.png" alt="Arrow back" class="logo" />
        </router-link>
        </div>

        <div class="card">
            
            <div class="box">
                <div>
                    <div class="percent">
                        <svg class="svgDark">
                            <circle cx="70" cy="70" r="70"></circle>
                            <circle class="cercle2" cx="70" cy="70" r="70"></circle>
                        </svg>
                        <div class="numberDark">
                            <h2 class="numberDark">70<span>%</span></h2>
                        </div>
                    </div>
                </div>
            </div>

            <div class="textDark text1">SCRUM</div>

        </div>

        <div class="card">

            <div class="box">
                <div>
                    <div class="percent">
                        <svg class="svgDark">
                            <circle cx="70" cy="70" r="70"></circle>
                            <circle class="cercle2" cx="70" cy="70" r="70"></circle>
                        </svg>
                        <div class="numberDark">
                            <h2>80<span>%</span></h2>
                        </div>
                    </div>
                </div>
            </div>

            <div class="textDark text2">Coopération</div>

        </div>

        <div class="card">

            <div class="box">
                <div>
                    <div class="percent">
                        <svg class="svgDark">
                            <circle cx="70" cy="70" r="70"></circle>
                            <circle class="cercle2" cx="70" cy="70" r="70"></circle>
                        </svg>
                        <div class="numberDark">
                            <h2>80<span>%</span></h2>
                        </div>
                    </div>
                </div>
            </div>

            <div class="textDark text3">Travail d'équipe</div>

        </div>

        <div class="card">

            <div class="box">
                <div>
                    <div class="percent">
                        <svg class="svgDark">
                            <circle cx="70" cy="70" r="70"></circle>
                            <circle class="cercle2" cx="70" cy="70" r="70"></circle>
                        </svg>
                        <div class="numberDark">
                            <h2>80<span>%</span></h2>
                        </div>
                    </div>
                </div>
            </div>

            <div class="textDark text3">Créativité</div>

        </div>

        <div class="card">

            <div class="box">
                <div>
                    <div class="percent">
                        <svg class="svgDark">
                            <circle cx="70" cy="70" r="70"></circle>
                            <circle class="cercle2" cx="70" cy="70" r="70"></circle>
                        </svg>
                        <div class="numberDark">
                            <h2>80<span>%</span></h2>
                        </div>
                    </div>
                </div>
            </div>

            <div class="textDark text4">Autonomie</div>

        </div>

  
    </div>

</section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['darkMode']),
  },

}
</script>

<style scoped>

*, ::before, ::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.h1Text{
    font-family: 'Holtwood One SC', sans-serif;
    -webkit-text-stroke: 0.2px #004080;
    color: transparent;
    padding-top: 20px;

}

.h1TextDark{
    font-family: 'Holtwood One SC', sans-serif;
    -webkit-text-stroke: 0.2px #fff;
    color: transparent;
    padding-top: 20px;
}

section{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    /* background-color: #f1f1f1; */
}

.mesLogos{
  position: absolute;
  top: -62px;
  left: 10px;
  z-index: 10;
}

.mesLogos img{
  width: 30px;
  height: auto;
}

.container{
    width: 100%;
    margin-top: -100px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.container .card{
    position: relative;
    width: 250px;
    height: 250px;
    text-align: center;
    z-index: 10;
    margin: 20px 20px 60px;
}

.container .card .box{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.05);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(15px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    z-index: 10;
    border-radius: 10px;

}

.percent{
    position: relative;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    z-index: 100;
}

.percent .number{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.percent .numberDark{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.percent .number h2{
    color: #000000;
    font-weight: 700;
    font-size: 40px;
}

.numberDark h2{
    color: #fff;
    font-weight: 700;
    font-size: 40px;
}


.percent .number h2 span{
    font-size: 20px;
}

.numberDark h2 span{
    font-size: 20px;
}

.text{
    position: absolute;
    bottom: -42px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    padding: 30px 20px 10px;
    background: #4798b8;
    border-radius: 10px;
    font-weight: 800;
    font-size: 18px;
    letter-spacing: 1px;
    text-transform: uppercase;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
    z-index: 1;
    pointer-events: none;
    transition: bottom 0.5s,
                z-index 0s, 
                transform 0.5s, 
                padding 0.5s;
    transition-delay: 0.5s, 0.5s, 0s, 0.5s;
    color: #000000;
    font-family: 'Quicksand', sans-serif;
}

.textDark{
    position: absolute;
    bottom: -42px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    padding: 30px 20px 10px;
    background: #4798b8;
    border-radius: 10px;
    font-weight: 800;
    font-size: 18px;
    letter-spacing: 1px;
    text-transform: uppercase;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
    z-index: 1;
    pointer-events: none;
    transition: bottom 0.5s,
                z-index 0s,
                transform 0.5s,
                padding 0.5s;
    transition-delay: 0.5s, 0.5s, 0s, 0.5s;
    color: #000000;
    font-family: 'Quicksand', sans-serif;
}

.card:hover .text{
    transition-delay: 0s, 0.5s, 0.5s, 0s;
    bottom: -70px;
    z-index: 11;
    transform: translateX(-50%) translateY(-50px);
    padding: 10px 20px 10px;
    color: #fff;
}


.card:hover .textDark{
    transition-delay: 0s, 0.5s, 0.5s, 0s;
    bottom: -70px;
    z-index: 11;
    transform: translateX(-50%) translateY(-50px);
    padding: 10px 20px 10px;
    color: #fff;
}

svg{
    position: relative;
    width: 150px;
    height: 150px;

}

svg circle{
    width: 100%;
    height: 100%;
    fill: none;
    stroke-width: 10;
    stroke: rgba(0, 0, 0, 0.05);
    transform: translate(5px, 5px);
    stroke-linecap: round;
}

svg circle:nth-child(2){
    stroke: #87CEEB;
    stroke-dasharray: 440px;
    stroke-dashoffset: 440px;
}

.card:nth-child(2) .box svg .cercle2{
    stroke-dashoffset: calc(440px - (440px * 70) / 100);
}

.card:nth-child(3) .box svg .cercle2{
    stroke-dashoffset: calc(440px - (440px * 80) / 100);
}

.card:nth-child(4) .box svg .cercle2{
    stroke-dashoffset: calc(440px - (440px * 80) / 100);
}

.card:nth-child(5) .box svg .cercle2{
    stroke-dashoffset: calc(440px - (440px * 80) / 100);
}

.card:nth-child(6) .box svg .cercle2{
    stroke-dashoffset: calc(440px - (440px * 80) / 100);
}

</style>